<template>
    <b-form-group>
        <v-select
            id="common-select-project"
            class="common-select"
            ref="common-select-project"
            v-model="projectModel"
            :options="projectOptions"
            :placeholder="projectPlaceholder"
            :clearable="clearable"
            @option:selected="handleSelectProject"
        >
        </v-select>
    </b-form-group>
</template>
<script>
import bus from '@/libs/bus'
import vSelect from 'vue-select'
import { watch, onUnmounted } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
export default {
    components: {
        vSelect
    },
    props: ['clearable', 'storeKey'],
    setup (props, context) {
        const {
            projectModel,
            selectedProject,
            projectOptions,
            projectPlaceholder,
            handleSelectProject,
            handleClearProject
        } = useSelectProjectAndGroup()

        watch(selectedProject, (value, oldValue) => {
            projectModel.value = projectOptions.value.find(opt => opt?.projectIdx === value?.projectIdx) ?? null
        }, {
            deep: true,
            immediate: true
        })
        bus.$on('vSelect:Deselect:common-select-project', handleClearProject)
        onUnmounted(() => {
            bus.$off('vSelect:Deselect:common-select-project', handleClearProject)
        })
        return {
            projectModel,
            projectOptions,
            projectPlaceholder,
            handleSelectProject
        }
    }
}
</script>
